import { light_offer } from "../../generated/models/light_offer";
import isSpecialCoupon from "./isSpecialCoupon";
import is10PercentOffCoupon from "./is10PercentOffCoupon";
import isCouponOutOfRange from "./isCouponOutOfRange";

type OfferWithOutOfRange = light_offer & {
  clippable_dates?: string | string[];
  isOutOfRange?: boolean;
  unavailable_clip_image_url?: string;
};

export default function getOfferIsOutOfRange(
  offer: OfferWithOutOfRange,
  now: Date,
): boolean {
  if (isSpecialCoupon(offer) || is10PercentOffCoupon(offer)) {
    return isCouponOutOfRange(offer, now);
  }
  return offer.isOutOfRange ?? false;
}
